import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react';
import Iconify from '../iconify';
import LoadingContainer from '../loaders/LoadingContainer';
import useInitState from '../../hooks/useInitState';
import ExecutivePatientInformation from './executive/ExecutivePatientInformation';
import ExecutivePatientsInCare from './executive/ExecutivePatientsInCare';
import ExecutiveLocationCardV2 from './executive/ExecutiveLocationCardV2';
import {  getAverageDataFromUsers, onGetCurrentPeriod, onGetFirstTimeAndFollowUpPatients } from '../../pages/Businesses/BusinessProgramPage/analytics_utils';
import { catalogs } from '../../utils/catalogs';
import ExecutiveObjectivesCardV2 from './executive/ExecutiveObjectivesCardV2';

const ExecutiveReport = ({
    locations,
    period,
    onReturn,
    appointments,
    program_users,
    
}) => {

    const {
        loading
    } = useInitState()

    const [global_appointment, setGlobalAppointment] = useState({
        "total_appointments": 7,
        "valid_appointments": "7",
        "scheduled_appointments": "2",
        "rescheduled_appointments": "0",
        "cancelled_appointments": "0",
        "completed_appointments": "5",
        "no_assistance_completed_appointments": "0",
        "appointments_per_user": "1.0000"
    })

    const [global_patient, setGlobalPatient] = useState({"total_users": 3,"initial_appointment_users": "0","scheduled_appointment_users": "2","pending_users": "1","invited_users": "0","registered_users": "0","disabled_users": "0","follow_up_appointment_users": "0"})

    const [location_patient, setLocationPatient] = useState([])
    const [users_objectives, setUsersObjectives] = useState([])
    const [average_metrics, setAverageMetrics] = useState()
    const [average_metrics_female, setAverageFemaleMetrics] = useState()
    const [average_metrics_male, setAverageMaleMetrics] = useState()

    // New analytics data
    const [patient_info, setPatientInfo] = useState()
    const [sites_info, setSitesInfo] = useState([])
    const [follow_up_data, setFollowUpData] = useState()
    const [first_time_data, setFirstTimeData] = useState()

    

   

    const onGetLocalData = useCallback(async() => {

        const validPeriod = onGetCurrentPeriod(period)
        if(!program_users.length) return
        console.log("Progra users", program_users)
        
        let patient_info = {}
        patient_info.total = program_users.length

        const {follow_up_users, first_time_users, valid_period_appointments} = onGetFirstTimeAndFollowUpPatients(program_users, appointments, validPeriod)
        patient_info.follow_up = follow_up_users.length
        patient_info.first_time = first_time_users.length

        setPatientInfo(patient_info)

        
        const _first_time_data = getAverageDataFromUsers(first_time_users)
        const _follow_up_data = getAverageDataFromUsers(follow_up_users)




        //await getAppointmentPatientaSegmentType(first_time_users, idclient)

        setFirstTimeData(_first_time_data)
        setFollowUpData(_follow_up_data)


        const allusers = [...first_time_users, ...follow_up_users]
        //await getAppointmentPatientaSegmentTypeBySite(allusers, idclient, locations)

        /* 
        ///////// ESTE CODIGO ES PARA VER EL TOTAL POR SITIO ///////////
        let data = [["Sitio","Pacientes", "IMC", "ICC Hombre", "ICC Mujer"]]

        const allusers = [...first_time_users, ...follow_up_users]
        for (let i = 0; i < locations.length; i++) {
            const location = locations[i];
            //console.log(location.id_client_location, location.name)
            const _usersfilter = allusers.filter(el => el.client_location_id === location.id_client_location)
            //console.log("Total", _usersfilter.length)
            const result = getAverageDataFromUsers(_usersfilter)
            data.push([
                location.name,
                _usersfilter.length,
                result.imc_average,
                result.icc_male_average,
                result.icc_female_average
            ])

            
        }
        console.log(data)
        console.log(JSON.stringify(data))
*/

        let _clientlocationsusers = []
        for (let index = 0; index < locations.length; index++) {
            const element = locations[index];
            const foundedusers = program_users.filter(el => el.user_client_location_id === element?.id_client_location)
            _clientlocationsusers.push({
                id_client_location: element?.id_client_location,
                name: element.name,
                count: foundedusers.length,
                percentage: (foundedusers.length / program_users.length)*100
            })
        }
        // Unclassified
        const tempusers = program_users.filter(el => el.user_client_location_id === null)
        _clientlocationsusers.push({
            id_client_location: -1,
            name: "Sin clasificar",
            count: tempusers.length,
            percentage: (tempusers.length / program_users.length)*100
        })
        //console.log(_clientlocationsusers)
        const sortedClientlocationsusers = _clientlocationsusers.sort((a, b) => b.count - a.count);
        setSitesInfo(sortedClientlocationsusers)

        let total_users_appointments = [...first_time_users, ...follow_up_users]
        let result_users_objectives = []
        for (let index = 0; index < catalogs.objectives.length; index++) {
            const objective = catalogs.objectives[index];
            let count = 0
            for (let j = 0; j < total_users_appointments.length; j++) {
                const user = total_users_appointments[j];
                let _appointment = null
                if(user.appointments_in_period.length > 0){
                    // Se verifica primero que se tenga al menos una consulta en el periodo seleccionado, sino se analizan las consultas anteriores
                    _appointment = user.appointments_in_period[0]
                }else if(user.appointments_before_period.length > 0){
                    // Se toma la ultima
                    const index = user.appointments_before_period.length - 1
                    _appointment = user.appointments_before_period[index]
                }
                if(_appointment.objective_id === objective.value){
                    count++;
                }
            }
            result_users_objectives.push({
                name:objective.label,
                count: count,
            })
        }

        setUsersObjectives(result_users_objectives)


        


    },[period, appointments, program_users])

    useEffect(() => {
        console.log("verificar")
        onGetLocalData()
    },[period, appointments, program_users])


    return ( 
        <Box>
            <Stack direction='row'>
                <IconButton onClick={onReturn}>
                    <Iconify icon="material-symbols:arrow-back-rounded" />
                </IconButton>
                <Typography variant='h5'>
                    Resumen ejecutivo
                </Typography>
                
            </Stack>
            <Box sx={{py:3}}>
                <LoadingContainer loading={loading.value}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Stack spacing={3}>
                                    <ExecutivePatientInformation 
                                        //total_patients={(global_patient?.total_users ?? 0) - (global_patient?.pending_users ?? 0)}
                                        //total_patients={info_?.total_users ?? 0}
                                        //attending_patients={(global_patient?.total_users ?? 0) - (global_patient?.pending_users ?? 0)}
                                        total_patients={patient_info?.total ?? 0}
                                        attending_patients={patient_info?.follow_up ?? 0}
                                        first_time_patients={patient_info?.first_time ?? 0}
                                    />
                                    <ExecutivePatientsInCare 
                                        title='Datos generales de colaboradores de primera vez'
                                        imc={first_time_data?.imc_average}
                                        weigth={first_time_data?.weight_average}
                                        icc_female={first_time_data?.icc_female_average}
                                        icc_male={first_time_data?.icc_male_average}
                                    />
                                    <ExecutivePatientsInCare 
                                        title='Datos generales de colaboradores en atención'
                                        imc={follow_up_data?.imc_average}
                                        weigth={follow_up_data?.weight_average}
                                        icc_female={follow_up_data?.icc_female_average}
                                        icc_male={follow_up_data?.icc_male_average}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack spacing={3}>
                                    <ExecutiveLocationCardV2 
                                        locations={sites_info}
                                    />
                                    <ExecutiveObjectivesCardV2
                                        objectives={users_objectives}
                                    />
                                </Stack>
                                
                            </Grid>
                        </Grid>
                    </LoadingContainer>
            </Box>
            
        </Box>
     );
}
 
export default ExecutiveReport;


/*
 const initialize = useCallback(async() => {
        const month = number2Digits((period?.month ?? 0)+1)
        const year = period?.year
        const startdate = `${year}-${month}-01` 
        const enddate = moment(startdate).endOf('month').format('YYYY-MM-DD')

        let params = {
            start_date:startdate,
            end_date:enddate,
            client_id:idclient,
            client_program_id:idclientprogram
        }

        loading.onTrue()
        try {
            const _patientdata = await getGlobalPatientCount({
                start_date:startdate,
                end_date:enddate,
                client_id:idclient,
                client_program_id:idclientprogram
            })
            setGlobalPatient(_patientdata)
            
        } catch (error) {
            console.log(error)
        }

        try {
            const _locationdata = await getLocationPatientCount({
                client_id:idclient,
                client_program_id: idclientprogram,
            })
            setLocationPatient(_locationdata)
        } catch (error) {
            console.log(error)
        }

        try {
            const _objectivesdata = await getUsersByObjective({
                start_date:startdate,
                end_date:enddate,
                client_id:idclient,
                client_program_id: idclientprogram,
            })
            setUsersObjectives(_objectivesdata)
            //setLocationPatient(_locationdata)
        } catch (error) {
            console.log(error)
        }

        try {
            const _averagemetricdata = await getAnalyticsAvergaMetrics({
                start_date:startdate,
                end_date:enddate,
                client_id:idclient,
                client_program_id: idclientprogram,
            })
            setAverageMetrics(_averagemetricdata)
        } catch (error) {
            console.log(error)
        }

        try {
            const _averagemetricmaledata = await getAnalyticsAvergaMetrics({
                start_date:startdate,
                end_date:enddate,
                client_id:idclient,
                client_program_id: idclientprogram,
                gender_id:GENDERS.MALE
            })
            setAverageMaleMetrics(_averagemetricmaledata)
        } catch (error) {
            console.log(error)
        }

        try {
            const _averagemetricfemaledata = await getAnalyticsAvergaMetrics({
                start_date:startdate,
                end_date:enddate,
                client_id:idclient,
                client_program_id: idclientprogram,
                gender_id:GENDERS.FEMALE
            })
            setAverageFemaleMetrics(_averagemetricfemaledata)
        } catch (error) {
            console.log(error)
        }
       
        loading.onFalse()

    }, [period, idclient, idclientprogram])

    useEffect(() => {
        //initialize()
    }, [])


*/